module.exports = __webpack_public_path__ + "static/img/047贷款app.314fb76.png";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/047贷款app.png
// module id = F3mD
// module chunks = 0